(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nov-product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nov-testimonials"] && !Shopify.designMode) return;
  try {
    

(function () {
  var COLLAPSED_HEIGHT = 175;
  var POST_SLICK_DELAY_MS = 200;

  function initCollapse(context) {
    var quotes = context.querySelectorAll('.testimonial-item__quote');

    quotes.forEach(function (el) {
      if (el.dataset.collapseInit === 'true') return;

      var oldMax = el.style.maxHeight;
      el.style.maxHeight = 'none';

      var fullHeight = el.scrollHeight;

      if (fullHeight <= COLLAPSED_HEIGHT) {
        el.style.maxHeight = oldMax || '';
        el.dataset.collapseInit = 'true';
        return;
      }

      el.classList.add('is-collapsed');
      el.style.maxHeight = COLLAPSED_HEIGHT + 'px';

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'testimonial-toggle';
      button.textContent = 'Mehr anzeigen';

      button.addEventListener('click', function () {
        var collapsed = el.classList.contains('is-collapsed');

        if (collapsed) {
          el.style.maxHeight = el.scrollHeight + 'px';
          el.classList.remove('is-collapsed');
          button.textContent = 'Weniger anzeigen';
        } else {
          el.style.maxHeight = COLLAPSED_HEIGHT + 'px';
          el.classList.add('is-collapsed');
          button.textContent = 'Mehr anzeigen';
        }
      });

      el.after(button);
      el.dataset.collapseInit = 'true';
    });
  }

  function afterSlickStable(slider, cb) {
    setTimeout(function () {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          cb(slider);
        });
      });
    }, POST_SLICK_DELAY_MS);
  }

  function waitForSlick() {
    var sliders = document.querySelectorAll('.nov-slick-carousel');

    if (!sliders.length) {
      requestAnimationFrame(waitForSlick);
      return;
    }

    var allReady = true;
    sliders.forEach(function (slider) {
      if (!slider.classList.contains('slick-initialized')) allReady = false;
    });

    if (!allReady) {
      requestAnimationFrame(waitForSlick);
      return;
    }

    sliders.forEach(function (slider) {
      if (slider.dataset.collapseHandled === 'true') return;
      slider.dataset.collapseHandled = 'true';

      afterSlickStable(slider, initCollapse);
    });
  }

  function boot() {
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(waitForSlick);
    } else {
      waitForSlick();
    }
  }

  boot();

  document.addEventListener('shopify:section:load', function () {
    boot();
  });
})();



  } catch(e) { console.error(e); }
})();
})();
